import React from 'react';

import SimpleHeader from '../../../../../main/headers/simpleHeader';

export default () => (
  <div>
    <SimpleHeader heading="Duplicate Records" />
    <div className="c-wrapper o-page-height">
      <div className="c-heading c-heading--small c-heading--semibold u-mt">
        No duplicates found
      </div>
    </div>
  </div>
);
